import React from "react";
import Loader from "./Loader";
import styles from "../Assets/Styles/fullLoading.module.css";

const items = [
  "محاسبه ( زمان های آزاد )",
  "محاسبه ( هزینه ایاب ذهاب )",
  "آماده سازی ( سطح متخصصین )",
  "آماده سازی ( دیدگاه کاربران )",
  " آماده سازی ( تجهیزات متخصص )"
];

const FullLoading = ({ showMessage }) => {
  const [counter, setCounter] = React.useState(0);
  React.useEffect(
    () => {
      const s = setInterval(() => {
        if (counter + 1 < items.length) {
          setCounter(c => c + 1);
        } else {
          setCounter(c => 0);
        }
      }, 2000);
      return () => clearInterval(s);
    },
    [counter]
  );
  return (
    <div className={styles.fullLoading}>
      <Loader scale="2" />
      {showMessage &&
        <p className={styles.message}>
          در حال {items[counter]}
        </p>}
    </div>
  );
};

export default FullLoading;
